import { motion } from 'framer-motion';
import { Calendar, FileText, Settings, ClipboardList } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import { Link } from 'react-router-dom';

import { staggerItem } from '../ui/motionVariants';

interface ActionItem {
  icon: LucideIcon;
  label: string;
  to: string;
  description: string;
}

const actions: ActionItem[] = [
  {
    icon: ClipboardList,
    label: 'Questionnaires',
    to: '/app/questionnaires',
    description: 'Complete pending forms',
  },
  {
    icon: FileText,
    label: 'View Report',
    to: '/app/report',
    description: 'Access latest insights',
  },
  {
    icon: Calendar,
    label: 'Book Session',
    to: '/app/bookings',
    description: 'Schedule with coach',
  },
  { icon: Settings, label: 'Profile', to: '/app/account', description: 'Update preferences' },
];

export function QuickActions(): JSX.Element {
  return (
    <motion.div
      variants={staggerItem}
      className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4"
    >
      {actions.map((action) => (
        <Link key={action.label} to={action.to} className="block group h-full">
          <motion.div
            whileHover={{ y: -2 }}
            transition={{ type: 'spring', stiffness: 400, damping: 25 }}
            className="flex flex-col gap-3 p-5 rounded-2xl border border-border bg-card hover:bg-sidebar-accent hover:border-primary/30 transition-all h-full ring-1 ring-foreground/5 shadow-soft group-hover:shadow-glow-brand"
          >
            <div className="w-10 h-10 flex items-center justify-center rounded-2xl bg-primary/10 text-primary">
              <action.icon className="w-5 h-5" />
            </div>
            <div>
              <p className="text-sm font-semibold text-foreground">{action.label}</p>
              <p className="text-xs text-muted-foreground mt-0.5">{action.description}</p>
            </div>
          </motion.div>
        </Link>
      ))}
    </motion.div>
  );
}
